module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Wel"
    }
  }, [_vm._v("Welcome to Spooky Columbia!")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Do you like spooks? I do, and that’s why I love Columbia, Missouri. Here, ghosts and spirits spill out of the town and into the countryside. In fact, there are so many ghosts in this part of the country that they can’t all fit in this book! Why are there so many of them? Maybe it’s because of all of the old battlefields. Or perhaps the people of Missouri aren’t afraid of spirits. In fact, some folks here even "), _c('i', [_vm._v("welcome")]), _vm._v(" ghosts.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Back in the 1800s and early 1900s, when disease and war took many before their time, Missouri was the center of the spiritualist movement. Back then, some people thought there were ways to communicate with the dead. After all, who wouldn’t want to communicate with a loved one who has passed? To make sure they were at peace and in a place that made them happy? Many Missourians did. So they held séances—gatherings where people try to contact the spirit world.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then, in 1890, Ouija (pronounced “wee- jee”) boards were invented. That’s a board with numbers and letters on it that people use to talk to spirits from beyond the grave. It was much more convenient to pull out a Ouija board than holding a séance . . . but it could still get super spooky!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The ghostly good news is, you won’t need to go to a séance or use a Ouija board to discover some of Columbia’s most famous spooks. In these pages, you’ll meet the spinster ghost who doesn’t like "), _c('i', [_vm._v("anyone")]), _vm._v(" peeking around her house. You’ll relive a Civil War battle with the spirits. And you’ll meet the (possibly haunted?) statue of John Neihardt himself, a pioneer in paranormal research. But that’s just the spine-tingling start. Because there are "), _c('i', [_vm._v("many")]), _vm._v(" more waiting for you (and they’ve been waiting a while). So grab a spooky snack, cozy up by the campfire, and read on!")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P10.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-182c9364","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome_to_Spooky_Columbia.vue
// module id = 75
// module chunks = 0